import { FailureSeverity } from '../../../../common/business-error/interfaces';

export type ActiveStepState = 'active' | 'loading' | FailureSeverity;

export type OnFailure = (failureSeverity: FailureSeverity) => void;
export type GoToNextStep = (userMsisdn?: string, shortcode?: string) => void;

export interface ContentHandlerProps {
  activeStepNumber: number;
  goToNextStep: GoToNextStep;
  onFailure: OnFailure;
  msisdn?: string;
  shortcode?: string;
}

export type StepProps = Omit<ContentHandlerProps, 'activeStepNumber'>;

export interface OtpData {
  otp: {
    smsOtp: string;
  };
}

export interface CreateNewClientProfileData {
  msisdn: string;
  emailAddress: string;
  name: string;
  country: string;
  callback: string;
}

export enum BUSINESS_ERRORS {
  'OTP_DELIVERY_FAILURE' = 'OTP_DELIVERY_FAILURE',
  'INCORRECT_OTP' = 'INCORRECT_OTP',
  'MISSING_OTP' = 'MISSING_OTP',
  'ORDER_NOT_FOUND' = 'ORDER_NOT_FOUND',
  'MSISDN_ALREADY_USED' = 'MSISDN_ALREADY_USED',
  'OTP_EXPIRED' = 'OTP_EXPIRED',
  'OTP_COULD_NOT_BE_SEND' = 'OTP_COULD_NOT_BE_SEND',
  'OTP_RESEND_BLOCKED' = 'OTP_RESEND_BLOCKED',
  'INCORRECT_MSISDN' = 'INCORRECT_MSISDN',
  'EMAIL_ALREADY_EXISTS' = 'EMAIL_ALREADY_EXISTS',
  'OTP_VERIFICATION_ERROR' = 'OTP_VERIFICATION_ERROR',
  'CLIENT_TO_CONFIRM_DOES_NOT_EXIST' = 'CLIENT_TO_CONFIRM_DOES_NOT_EXIST',
  'PENDING_CLIENT_PROFILE_EXPIRED' = 'PENDING_CLIENT_PROFILE_EXPIRED'
}
